import React, { useState } from 'react';
import { FiMail, FiMapPin } from 'react-icons/fi';
import '../styles/contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-page">
      <div className="contact-content">
        <div className="contact-header">
          <h1>Connect With PCDS INFOTECH</h1>
          <p className="subtitle">We're here to help you grow your digital presence</p>
        </div>

        <div className="contact-main">
          <div className="contact-form-container">
            <div className="contact-form">
              <h2>
                <span className="icon-circle"><FiMail size={18} /></span>
                Send Us a Message
              </h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="Phone Number (Optional)"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            </div>
          </div>

          <div className="office-locations">
            <h2>
              <span className="icon-circle"><FiMapPin size={18} /></span>
              Our Office Locations
            </h2>
            <div className="office-grid">
              <div className="office-column">
                <div className="office-card">
                  <h3>Corporate Office</h3>
                  <div className="contact-method">
                    <FiMapPin className="icon" size={16} />
                    <p>1st Floor Mukta tawar Near Andheri Station, Andheri West, Mumbai - 400058</p>
                  </div>
                  <div className="contact-method">
                    <FiMail className="icon" size={16} />
                    <p className="email">info@PCDS.in</p>
                  </div>
                </div>
                
                <div className="office-card">
                  <h3>Mumbai Office</h3>
                  <div className="contact-method">
                    <FiMapPin className="icon" size={16} />
                    <p>Laxmi Park, Kankiya, Mira Road(E), Mumbai - 401107</p>
                  </div>
                  <div className="contact-method">
                    <FiMail className="icon" size={16} />
                    <p className="email">info@PCDS.com</p>
                  </div>
                </div>
                
                <div className="office-card">
                  <h3>Bhandup Office</h3>
                  <div className="contact-method">
                    <FiMapPin className="icon" size={16} />
                    <p>No. 1/343 Dream Mall, Near PMC Bank, Bhandup West - 400078</p>
                  </div>
                  <div className="contact-method">
                    <FiMail className="icon" size={16} />
                    <p className="email">info@PCDS.com</p>
                  </div>
                </div>
              </div>
              
              <div className="office-column">
                <div className="office-card">
                  <h3>Hyderabad Office</h3>
                  <div className="contact-method">
                    <FiMapPin className="icon" size={16} />
                    <p>2nd floor Wing D Girdhari complex, Bandlaguda, Hyderabad - 500068</p>
                  </div>
                  <div className="contact-method">
                    <FiMail className="icon" size={16} />
                    <p className="email">info@PCDS.com</p>
                  </div>
                </div>
                
                <div className="office-card">
                  <h3>Bangalore Office</h3>
                  <div className="contact-method">
                    <FiMapPin className="icon" size={16} />
                    <p>1st floor, 3rd Main N S Palya, 6, BTM 2nd Stage, Bangalore - 560076</p>
                  </div>
                  <div className="contact-method">
                    <FiMail className="icon" size={16} />
                    <p className="email">info@PCDS.com</p>
                  </div>
                </div>
                
                <div className="office-card">
                  <h3>Pune Office</h3>
                  <div className="contact-method">
                    <FiMapPin className="icon" size={16} />
                    <p>Sno 122, Sutarwad, Pashan, Pune - 411021</p>
                  </div>
                  <div className="contact-method">
                    <FiMail className="icon" size={16} />
                    <p className="email">info@PCDS.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="map-section">
          <h2>
            <span className="icon-circle"><FiMapPin size={18} /></span>
            Find Us On The Map
          </h2>
          <div className="map-container">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15064.018419865244!2d72.87653655!3d19.28216595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b0458cf7298b%3A0x468ed839e9df2b21!2sMira+Road+East%2C+Mira+Bhayandar%2C+Maharashtra!5e0!3m2!1sen!2sin!4v1420201907383"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;